import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {DocumentDetailsService} from '../../../service/document-details.service';
import swal from "sweetalert2";
import {FormControl, FormGroup} from '@angular/forms';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {DocumentTypeService} from '../../../service/document-type.service';
import {ApplicantRequestService} from '../../../service/applicant-request.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NgWizardService} from 'ng-wizard';
import {DocumentScannerComponent} from '../../../dashboard/online-application-detail/document-scanner/document-scanner.component';
import {BlacklistDocumentModel} from '../../../shared/dto/blacklist-document.model';
import {ActivatedRoute} from '@angular/router';
import {ReversedBlacklistService} from '../../../shared/service/reversed-blacklist.service';

@Component({
  selector: 'app-reversed-document-details',
  templateUrl: './reversed-document-details.component.html',
  styleUrls: ['./reversed-document-details.component.scss']
})
export class ReversedDocumentDetailsComponent implements OnInit {
  @Output() response = new EventEmitter<BlacklistDocumentModel>();

  files: File[] = [];
  addedFiles: File[] = [];
  documentTypes: any = [];
  documentDetails: any = [];
  selectedImage: any = [];
  savedImages: any = [];
  requestId: number;
  documentDetail: BlacklistDocumentModel;

  constructor(private route: ActivatedRoute,
              private modalService: NgbModal,
              private ngWizardService: NgWizardService,
              public applicantRequestService: ApplicantRequestService,
              public documentTypeService: DocumentTypeService,
              private spinnerService: NgxUiLoaderService,
              private documentDetailsService: DocumentDetailsService,
              private blackListService: ReversedBlacklistService) {
    this.route.paramMap.subscribe(params => {
      this.requestId = +this.decodeBase64(params.get('id'));
    });
  }


  documentUploadFrom = new FormGroup({
    document_type: new FormControl('')
  });

  ngOnInit() {
    this.onLoadDocumentType();

  }

  decodeBase64(code: string): string {
    return atob(code);
  }


  onScann() {
    const modalRef = this.modalService.open(DocumentScannerComponent, {
      windowClass: 'xlModal'
    });
  }


  onSubmit(element) {
    // http://localhost:8081/api/applicant/uploadFile
    this.spinnerService.start();
    const formData: FormData = new FormData();
    formData.append('file', element);

    this.applicantRequestService.uploadFiles(formData).subscribe(
      (result: any) => {
        this.spinnerService.stop();
        this.getSavedDocumentDetailsFromDocumentId(result.result);
        swal.fire(result.messageStatus , result.message, result.messageClass);
      }, (error) => {
        console.error(error);
        this.spinnerService.stop();
      }
    );
  }

  onSelect(event) {
    this.addedFiles.push(...event.addedFiles);
    this.files = [];
    this.files.push(...event.addedFiles);

    for (var i = 0; i < this.files.length; i++) {
      this.onSubmit(this.files[i]);
    }
  }

  onRemove(event) {
    console.log(event);
    this.files.splice(this.files.indexOf(event), 1);
  }

  onLoadDocumentType() {
    this.documentTypeService.getAllDocumentType().subscribe(
      (result: any) => {
        this.documentTypes = result;
      }
    );
  }

  getSavedDocumentDetailsFromDocumentId(id) {
    this.documentDetailsService.getAllDocumentType(id).subscribe(
      (result: any) => {
        result.forEach(element => {
          this.documentDetails.push(element);
        });
      }
    );
  }

  onSelectImage(item) {
    if (this.selectedImage.includes(item)) {
      // remove
      const index = this.selectedImage.indexOf(item);

      if (index > -1) {
        this.selectedImage.splice(index, 1);
      }

    } else {
      this.selectedImage.push(item);
    }
    console.log(this.selectedImage);
  }

  saveDocumentTypeAndDetails() {
    const document_type1 = this.documentUploadFrom.controls['document_type'].value;

    if (document_type1 !== '' ) {
      const documentUploadFromData = {
        pageList: this.selectedImage,
        document_type: document_type1,
        requestId: this.requestId
      };

      const copyOfDetails = [...this.documentDetails];
      this.documentDetails = [];
      this.selectedImage = [];

      this.blackListService.saveDocumentTypeAndDetails(documentUploadFromData).subscribe(
        (result: any) => {
          let myMap = new Map();

          copyOfDetails.forEach(element => {
            myMap.set(element.document.documentId, element.document.documentId);
          });

          myMap.forEach(element => {
            this.getSavedDocumentDetailsFromDocumentId(element);
          });
        }
      );
      this.documentDetail = documentUploadFromData;
      this.response.emit(this.documentDetail);
    } else {
      swal.fire('error' , 'Select a Document Type', 'error');
    }

  }


}
